import { useEffect } from 'react';

// Component to set security headers via meta tags
// Note: Some headers can only be set by the server, but we set what we can on the client
export const SecurityHeaders = () => {
  useEffect(() => {
    // Set Content Security Policy via meta tag
    const cspMeta = document.createElement('meta');
    cspMeta.httpEquiv = 'Content-Security-Policy';
    cspMeta.content = [
      "default-src 'self'",
      "script-src 'self' 'unsafe-inline' 'unsafe-eval' https://cdn.onesignal.com https://onesignal.com",
      "style-src 'self' 'unsafe-inline'",
      "img-src 'self' data: https: blob:",
      "font-src 'self' data:",
      "connect-src 'self' https://*.supabase.co https://ai.gateway.lovable.dev https://cdn.onesignal.com wss://*.supabase.co",
      "frame-src 'self' https://checkout.stripe.com https://js.stripe.com",
      "frame-ancestors 'none'",
      "object-src 'none'",
      "base-uri 'self'",
      "form-action 'self'",
      "upgrade-insecure-requests"
    ].join('; ');
    document.head.appendChild(cspMeta);

    // Set X-Frame-Options to prevent clickjacking
    const xFrameMeta = document.createElement('meta');
    xFrameMeta.httpEquiv = 'X-Frame-Options';
    xFrameMeta.content = 'DENY';
    document.head.appendChild(xFrameMeta);

    // Set X-Content-Type-Options
    const noSniffMeta = document.createElement('meta');
    noSniffMeta.httpEquiv = 'X-Content-Type-Options';
    noSniffMeta.content = 'nosniff';
    document.head.appendChild(noSniffMeta);

    // Set Referrer Policy
    const referrerMeta = document.createElement('meta');
    referrerMeta.name = 'referrer';
    referrerMeta.content = 'strict-origin-when-cross-origin';
    document.head.appendChild(referrerMeta);

    // Set Permissions Policy - allow camera for receipt scanning, restrict other sensitive APIs
    const permissionsMeta = document.createElement('meta');
    permissionsMeta.httpEquiv = 'Permissions-Policy';
    permissionsMeta.content = 'camera=(self), microphone=(), geolocation=(), payment=(self "https://checkout.stripe.com"), accelerometer=(), gyroscope=(), magnetometer=(), usb=()';
    document.head.appendChild(permissionsMeta);

    return () => {
      // Cleanup on unmount
      document.head.removeChild(cspMeta);
      document.head.removeChild(xFrameMeta);
      document.head.removeChild(noSniffMeta);
      document.head.removeChild(referrerMeta);
      document.head.removeChild(permissionsMeta);
    };
  }, []);

  return null;
};
